jQuery( document ).ready( function ( $ ) {
	$( '.menu>li>a.local' ).on( 'click', function ( e ) {
		e.preventDefault();
		const href = $( this ).attr( 'href' );
		const pos = $( href ).offset();
		$( 'html, body' ).animate( {scrollTop: pos.top}, 1000 );
	} );
} );